import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Copy, Check, Eye, Mail } from 'lucide-react';

interface EmailRevealSectionProps {
    hasEmail?: boolean;
    revealedEmail: string | null;
    isLoading: boolean;
    onReveal: () => void;
}

export const EmailRevealSection: React.FC<EmailRevealSectionProps> = ({
    hasEmail,
    revealedEmail,
    isLoading,
    onReveal
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (revealedEmail) {
            navigator.clipboard.writeText(revealedEmail);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    if (!hasEmail && !revealedEmail) {
        return <span className="text-sm text-gray-400">Not Available</span>;
    }

    if (!revealedEmail) {
        return (
            <Button
                variant="outline"
                onClick={onReveal}
                disabled={isLoading}
                className="w-full max-w-[300px] border-dashed border-2 border-primary text-primary hover:text-primary hover:bg-primary/10 hover:border-primary"
            >
                {isLoading ? (
                    <span className="animate-spin mr-2 h-4 w-4 border-2 border-current border-t-transparent rounded-full" />
                ) : (
                    <Eye className="mr-2 h-4 w-4" />
                )}
                Reveal Email Address
            </Button>
        );
    }

    return (
        <div className="flex items-center gap-2 p-2 bg-primary/10 border border-primary/20 rounded-lg w-fit max-w-full">
            <Mail className="h-4 w-4 text-primary shrink-0" />
            <span className="font-medium text-gray-900 truncate select-all">
                {revealedEmail}
            </span>
            <Button
                variant="ghost"
                size="icon"
                onClick={handleCopy}
                className="h-8 w-8 text-gray-500 hover:text-primary hover:bg-primary/20 rounded-full"
                title="Copy email"
            >
                {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
            </Button>
        </div>
    );
};
